import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "primaryColorOrange" }, "Home", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { theme: _ctx.theme }, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, { elevation: 2 }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCurrentPage('home-view')))
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCurrentPage('request-tutor-view')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Request Tutor ")
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setCurrentPage('module-management')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Module Management ")
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setCurrentPage('tutorial-session-admin')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Manage Tutorial Sessions ")
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            "prepend-icon": _ctx.theme === 'light' ? 'mdi-weather-sunny' : 'mdi-weather-night',
            onClick: _ctx.toggleTheme
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.theme), 1)
            ]),
            _: 1
          }, 8, ["prepend-icon", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["theme"]))
}